import ManageRouter from '../router/MangeRoute'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import Notifications from 'vue-notification'
import Iconly from "vue-iconly";
import DataTable from '../components/DataTable.vue'
import Loader from '../components/Loader.vue'
import CKEditor from 'ckeditor4-vue';

const GlobalComponents = {
    // use packages
    install(Vue) {
        Vue.use(VuePersianDatetimePicker, {
            name: 'custom-date-picker',
            props: {
              inputFormat: 'YYYY/MM/DD',
              format: 'jYYYY/jMM/jDD',
              editable: false,
              inputClass: 'form-control my-custom-class-name',
              placeholder: 'Please select a date',
              altFormat: 'YYYY/MM/DD',
              color: '#28394b',
              autoSubmit: true,
            }
          });

        Vue.use(ManageRouter)
        Vue.component('tk-table', DataTable)
        Vue.use(Iconly);
        Vue.use( CKEditor )
        Vue.component('date-picker', VuePersianDatetimePicker);
        Vue.component('Loader', Loader)
        Vue.use(Notifications)
    }
};

export default GlobalComponents;
